import React from 'react';
import { Document, Page } from 'react-pdf';
import { IcertificateDetails } from '../../TypesAndInterfaces';
import CertificateCarousel from './CertificateCarousel';
import { getCertificatePdfUrl } from '../utils/certificateUtils';

interface CertificateViewerProps {
  certificateDetails: IcertificateDetails;
  allCertificates: IcertificateDetails[];
  selectedIndex: number;
  onSelectCertificate: (index: number) => void;
  isCareerPath: boolean;
  isCertLoading: boolean;
  onLoadSuccess: () => void;
}

const CertificateViewer: React.FC<CertificateViewerProps> = ({
  certificateDetails,
  allCertificates,
  selectedIndex,
  onSelectCertificate,
  isCareerPath,
  isCertLoading,
  onLoadSuccess,
}) => {
  const pdfUrl = getCertificatePdfUrl(certificateDetails?.certificate?.id, isCareerPath);
  return (
    <div className="w-[100%] large:!w-[70%] flex flex-col">
      <CertificateCarousel
        certificates={allCertificates}
        selectedIndex={selectedIndex}
        onSelect={onSelectCertificate}
      >
        {certificateDetails?.certificate?.id && (
          <div className="relative">
            {isCertLoading && (
              <div className="inset-0 flex items-center justify-center bg-white z-10 aspect-[1.414/1]">
                <div className="flex flex-col items-center gap-2">
                  <div className="w-8 h-8 border-4 border-[#E97862] border-t-transparent rounded-full animate-spin" />
                  <span className="text-gray-500 text-sm">Loading certificate...</span>
                </div>
              </div>
            )}
            <Document
              key={`main-cert-${certificateDetails?.certificate?.id}`}
              file={pdfUrl}
              loading=""
              onLoadSuccess={onLoadSuccess}
              className="!max-w-full p-[10px] bg-white"
            >
              <Page
                pageNumber={1}
                loading=""
                _className="!w-[100%] !h-[90%] "
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            </Document>
          </div>
        )}
      </CertificateCarousel>

      <div>
        <span className="inline-block mt-[10px] font-normal text-[16px] text-[#3D3D3D]">
          <sup>*</sup>This certificate verifies the authenticity and completion of whatsoever
          program from PW Skills by any particular student.
        </span>
      </div>
    </div>
  );
};

export default CertificateViewer;
